module.exports = __webpack_public_path__ + "img/flow-desc1.14851978.png";